import styled from "@emotion/styled";

export const PermissionEditorContentRoot = styled.div`
  padding-left: 40px;
`;

export const EditorFilterContainer = styled.div`
  margin: 1rem 0 0.5rem 0;
  width: 17.5rem;
`;

export const EditorEmptyStateContainer = styled.div`
  margin-top: 7.5rem;
`;

export const PermissionTableWrapper = styled.div`
  position: relative;
  overflow-x: auto;
  padding-bottom: 20px;
`;
